<template>
    <div class="page-container">
        <div class="banner-wrapper">
            <img src="@/assets/img/ebanner.png" alt="" class="banner">
        </div>
        <div class="page-content">
            <div class="title-container">
                <div class="title-wrapper">
                    <img src="@/assets/img/title2.png" alt="" class="title-img">
                    <div class="title-label">精选课程</div>
                </div>
                <div class="more-btn">
                    更多 <img src="@/assets/img/more.png" alt="" class="more-img">
                </div>
            </div>
            <div class="selected-course-container">
                <div v-for="(item,key) in selectedCourse" :key="key" class="selected-course-item">
                    <img src="@/assets/img/1.png" alt="" class="selected-course-img">
                    <div class="selected-course-content-wrapper">
                        <div class="selected-course-content">
                            <div class="selected-course-label">
                                {{item.title}}
                            </div>
                            <div class="selected-course-brief">
                                <div class="selected-course-price">￥{{item.price}}</div>
                                <div class="selected-course-teacher">讲师：{{item.name}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="title-container">
                <div class="title-wrapper">
                    <img src="@/assets/img/title3.png" alt="" class="title-img">
                    <div class="title-label">认证课程</div>
                </div>
            </div>
            <div class="certification-course-wrapper">
                <div class="certification-course">
                    <img src="@/assets/img/rz1.png" alt="" class="certification-course-img">
                    <div class="certification-course-label">高级管理会计</div>
                </div>
                <div class="certification-course">
                    <img src="@/assets/img/rz2.png" alt="" class="certification-course-img">
                    <div class="certification-course-label">高级管理会计</div>
                </div>
            </div>
             <div class="certification-course-wrapper">
                <div class="certification-course">
                    <img src="@/assets/img/rz3.png" alt="" class="certification-course-img">
                    <div class="certification-course-label">高级管理会计</div>
                </div>
                <div class="certification-course">
                    <img src="@/assets/img/rz4.png" alt="" class="certification-course-img">
                    <div class="certification-course-label">高级管理会计</div>
                </div>
            </div>

            <div class="title-container">
                <div class="title-wrapper">
                    <img src="@/assets/img/title1.png" alt="" class="title-img">
                    <div class="title-label">精彩直播</div>
                </div>
            </div>
            <div class="wonderful-live-wrapper">
                <div class="wonderful-live-list">
                    <div v-for="(item,index) in wonderfulCourse" :key="'wonderful-'+index" 
                    class="wonderful-live-list-item" :style="index==wonderfulCourse.length-1?'margin-bottom:0px;':''">
                        <div class="wonderful-live-list-content">
                            <div class="wonderful-live-list-label-wrapper">
                                <div class="wonderful-live-list-label">
                                    {{item.title}}
                                </div>
                                <div class="wonderful-live-list-flag">付费</div>
                            </div>
                            <div class="wonderful-live-list-date">
                                {{item.date}}直播
                            </div>
                        </div>
                        <div class="wonderful-live-list-btn">立即观看</div>
                        <div class="wonderful-live-dat-wrapper">
                            <div class="wonderful-live-dat"></div>
                            <div v-if="index!=wonderfulCourse.length-1" class="wonderful-live-line"></div>
                        </div>
                    </div>
                </div>
                <div class="wonderful-live-info">
                    <div class="wonderful-live-info-img-wrapper">
                        <img src="@/assets/img/w1.png" alt="" class="wonderful-live-info-img">
                    </div>
                    <div class="wonderful-live-info-img-wrapper">
                        <img src="@/assets/img/w2.png" alt="" class="wonderful-live-info-img">
                    </div>
                </div>
            </div>


            <div class="title-container">
                <div class="title-wrapper">
                    <img src="@/assets/img/title4.png" alt="" class="title-img">
                    <div class="title-label">大咖推荐</div>
                </div>
                <div class="more-btn">
                    更多 <img src="@/assets/img/more.png" alt="" class="more-img">
                </div>
            </div>
            <div class="recommend-container">
                <div class="recommend-wrapper">
                    <div class="recommend-content" :style="'left:'+recommendDistance+'px;'">
                        <div v-for="(item,key) in recommendData" :key="key" class="recommend-item-wrapper">
                            <div class="recommend-item">
                                <div class="recommend-img-wrapper">
                                    <img src="https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png" alt="" class="recommend-img">
                                </div>
                                <div class="recommend-name">{{item.name}}</div>
                                <div class="recommend-role">{{item.role}}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="recommend-right-img-wrapper">
                    <img src="@/assets/img/right2.png" alt="" class="recommend-right-img" 
                    @click="transforRecommend">
                </div>
            </div>


            <div class="title-container">
                <div class="title-wrapper">
                    <img src="@/assets/img/title5.png" alt="" class="title-img">
                    <div class="title-label">会员服务</div>
                </div>
            </div>
            <div class="services-container">
                <div class="services-wrapper">
                    <div class="services-item" style="background: linear-gradient(114deg, #B8BFD4 0%, #7B8BAE 100%);">
                        <div class="services-item-label">智能银卡</div>
                        <div class="services-item-brief">你最优的选择</div>
                    </div>
                    <div class="services-item" style="background: linear-gradient(114deg, #E8CE91 0%, #BDA369 100%);">
                        <div class="services-item-label">智能金卡</div>
                        <div class="services-item-brief">你最优的选择</div>
                    </div>
                    <div class="services-item" style="background: linear-gradient(114deg, #65656F 0%, #3F4249 100%);">
                        <div class="services-item-label">智能黑金卡</div>
                        <div class="services-item-brief">你最优的选择</div>
                    </div>
                </div>
                <div class="services-right-wrapper">
                    <img src="@/assets/img/right3.png" alt="" class="services-right">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: '',
    components:{
      
    },
    data() {
        return {
            selectedCourse:[
                {
                    title:'2021执行的《民法典》下合同、财务、税务协同创新管理',
                    price:3280,
                    name:'李老师'
                },
                {
                    title:'2021执行的《民法典》下合同、财务、税务协同创新管理',
                    price:3280,
                    name:'李老师'
                },
                {
                    title:'2021执行的《民法典》下合同、财务、税务协同创新管理',
                    price:3280,
                    name:'李老师'
                },
                {
                    title:'2021执行的《民法典》下合同、财务、税务协同创新管理',
                    price:3280,
                    name:'李老师'
                }
            ],
            wonderfulCourse:[
                {
                    title:'注会-审计-3月31日直播',
                    date:'2022-03-31  19:00:00'
                },
                {
                    title:'注会-审计-3月31日直播',
                    date:'2022-03-31  19:00:00'
                },
                {
                    title:'注会-审计-3月31日直播',
                    date:'2022-03-31  19:00:00'
                },
                {
                    title:'注会-审计-3月31日直播',
                    date:'2022-03-31  19:00:00'
                },
                {
                    title:'注会-审计-3月31日直播',
                    date:'2022-03-31  19:00:00'
                }
            ],
            recommendData:[
                {
                    name:'李秀华',
                    role:'高级讲师'
                },
                {
                    name:'李秀华',
                    role:'高级讲师'
                },
                {
                    name:'李秀华',
                    role:'高级讲师'
                },
                {
                    name:'李秀华',
                    role:'高级讲师'
                },
                {
                    name:'李秀华',
                    role:'高级讲师'
                },
                {
                    name:'李秀华',
                    role:'高级讲师'
                },
                {
                    name:'李秀华',
                    role:'高级讲师'
                },
                {
                    name:'李秀华',
                    role:'高级讲师'
                },
                {
                    name:'李秀华',
                    role:'高级讲师'
                },
                {
                    name:'李秀华',
                    role:'高级讲师'
                },
                {
                    name:'李秀华',
                    role:'高级讲师'
                },
                {
                    name:'李秀华',
                    role:'高级讲师'
                },
                {
                    name:'李秀华',
                    role:'高级讲师'
                },
                {
                    name:'李秀华',
                    role:'高级讲师'
                },
                {
                    name:'李秀华',
                    role:'高级讲师'
                },
                {
                    name:'李秀华',
                    role:'高级讲师'
                },
                {
                    name:'李秀华',
                    role:'高级讲师'
                },
                {
                    name:'李秀华',
                    role:'高级讲师'
                },
                {
                    name:'李秀华',
                    role:'高级讲师'
                },
                {
                    name:'李秀华',
                    role:'高级讲师'
                },
            ],
            recommendNum:0,
            recommendDistance:0
        }
    },
    mounted(){
        scrollTo(0,0);
    },
    methods: {
        transforRecommend(){
            var recommendNum=this.recommendNum;
            var totalNum=this.recommendData.length;
            if(recommendNum<totalNum-5){
                var swiperNum=recommendNum+1;
                this.recommendDistance=swiperNum*200*(-1);
                this.recommendNum=swiperNum;
            }else{
                this.recommendDistance=0;
                this.recommendNum=0;
            }
        }
    }
}
</script>

<style scoped>
.page-container{
    margin-top:100px;
    padding-bottom:100px;
}
.banner-wrapper{
    width:100%;
}
.banner{
    width:100%;
    height:483px;
}
.page-content{
    width:1200px;
    margin:0 auto;
}
.title-container{
    display:flex;
    justify-content: space-between;
    align-items: center;
    padding-top:43px;
}
.title-wrapper{
    display: flex;
    align-items: center;
}
.title-label{
    font-size: 20px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #333333;
    margin-left:10px;
}
.title-img{
    width:29px;
    height:23px;
}
.more-btn{
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
    display: flex;
    align-items: center;
    cursor:pointer;
}
.more-img{
    width:10px;
    display:inline-block;
    position:relative;
    margin-left:5px;
    top:1px;
}
.selected-course-container{
    display:flex;
    justify-content: space-between;
}
.selected-course-item{
    width:285px;
    background: #FFFFFF;
    border-radius: 5px;
    margin-top:20px;
}
.selected-course-img{
    width:100%;
    height:160px;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
}
.selected-course-content-wrapper{
    display: flex;
}
.selected-course-content{
    flex:1;
    margin:13px 13px 20px 13px;
}
.selected-course-label{
    width:100%;
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #333333;
    line-height: 22px;
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
}
.selected-course-brief{
    display: flex;
    justify-content: space-between;
    margin-top:13px;
}
.selected-course-price{
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
}
.selected-course-teacher{
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
}
.certification-course-wrapper{
    display:flex;
    justify-content: space-between;
}
.certification-course{
    width:590px;
    height:186px;
    margin-top:20px;
    position:relative;
}
.certification-course-img{
    width:100%;
    height:100%;
}
.certification-course-label{
    width:100%;
    height:100%;
    position:absolute;
    top:0px;
    left:0px;
    font-size: 24px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #292C2E;
    display: flex;
    justify-content: center;
    align-items: center;
}
.wonderful-live-wrapper{
    margin-top:20px;
    display:flex;
    justify-content: space-between;
}
.wonderful-live-list{
    flex:1;
    margin-right:110px;
}
.wonderful-live-info{
    width:500px;
}
.wonderful-live-list-item{
    display:flex;
    justify-content: space-between;
    margin-bottom:42px;
    position:relative;
}
.wonderful-live-list-btn{
    width: 98px;
    height: 34px;
    background: #3E63EE;
    border-radius: 6px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    text-align: center;
    line-height:34px;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
}
.wonderful-live-list-btn:hover{
    cursor: pointer;
    opacity:0.8;
}
.wonderful-live-list-label-wrapper{
    display:flex;
    margin-left:24px;
}
.wonderful-live-list-label{
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #333333;
}
.wonderful-live-list-flag{
    width: 34px;
    height: 20px;
    background: #E6F2FF;
    border-radius: 1px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #0F6CF5;
    display:flex;
    justify-content: center;
    align-items: center;
    margin-left:10px;
}
.wonderful-live-list-date{
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    margin-top:10px;
    margin-left:24px;
}
.wonderful-live-dat-wrapper{
    position:absolute;
    left:0px;
    top:7px;
}
.wonderful-live-dat{
    width: 10px;
    height: 10px;
    background: #0F6CF5;
    border-radius:50%;
}
.wonderful-live-line{
    width: 1px;
    height: 55px;
    background: #ADC3E6;
    position:relative;
    left:4px;
    top:13px;
}
.wonderful-live-info-img-wrapper{
    width:100%;
    margin-bottom:20px;
}
.wonderful-live-info-img{
    width:100%;
    height:186px;
}
.recommend-container{
    margin-top:23px;
    height: 312px;
    background: linear-gradient(180deg, #FAFCEE 0%, #F9F9F9 100%);
    border-radius: 6px;
    position:relative;
}
.recommend-wrapper{
    width:1000px;
    height:100%;
    position:relative;
    margin-left:50px;
    overflow:hidden;
}
.recommend-content{
    width:100%;
    height:100%;
    display:flex;
    position:absolute;
    left:0px;
    top:0px;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
}
.recommend-item{
    width:200px;
    display: flex;
    flex-direction: column;
    align-items: center;
}
.recommend-img-wrapper{
    width: 164px;
    height: 164px;
    border: 1px solid #96B377;
    border-radius:50%;
    margin-top:34px;
    text-align: center;
}
.recommend-img{
    width:100%;
    height:100%;
    border-radius:50%;
}
.recommend-name{
    font-size: 18px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #333333;
    text-align: center;
    margin-top:27px;
}
.recommend-role{
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #86A763;
    margin-top:8px;
    text-align: center;
}
.recommend-right-img-wrapper{
    position: absolute;
    right:0px;
    top:0px;
    width:150px;
    height:100%;
    display:flex;
    align-items: center;
    justify-content: center;
}
.recommend-right-img{
    width:22px;
    height:38px;
    cursor:pointer;
}
.services-container{
    width:100%;
    position:relative;
    margin-top:50px;
}
.services-wrapper{
    width:1200px;
    height:209px;
    position: relative;
    display:flex;
}
.services-item{
    width: 349px;
    height: 209px;
    border-radius: 10px;
    display:flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-right:44px;
}
.services-item-label{
    font-size: 26px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #FFFFFF;
}
.services-item-brief{
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    margin-top:10px;
}
.services-right-wrapper{
    height:100%;
    display:flex;
    align-items: center;
    position:absolute;
    right:0px;
    top:0px;
}
.services-right{
    width:22px;
    height:38px;
    cursor:pointer;
}
</style>


